<template>
    <div class="authorize">
        <div class="authorize-tip">
            <p>亲爱的开发者，您的应用发布后，共享充电开放平台的技术</p>
            <p>支持同事将与您取得联系，协助您授权开通站点使用权限。</p>
        </div>
        <div class="btn-cont">
            <el-button type="primary" @click="publishApp">立即发布应用</el-button>
        </div>
    </div>
</template>
<script>
import { Message } from 'element-ui';
import {http, apiJson} from "@/utils/http"
export default {
    data () {
        return {
            
        }
    },
    created () {
        this.$store.dispatch('changeDefaultActive','authorize')
    },
    updated () {
        console.log("sss")
    },
    methods: {
        publishApp () {
            let {params} = this.$route
            http(apiJson.publishApp, {appId: params.id}).then(res => {
                if(res.code == 0 && res.data) {
                    this.$store.dispatch('showCoverAuthorize', res.data)
                }else {
                    Message.error('接口调用错误')
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .authorize {
        width: 100%;
        height: 920px;
        border-left: 1px solid #e5e5e5;
        .authorize-tip {
            width: 500px;
            margin: 191px auto 72px;
            p {
                font-size: 16px;
                color: #333333;
                line-height: 28px;
                text-align: center;
            }
        }
        .btn-cont {
            width: 500px;
            margin: 0 auto;
            .el-button {
                display: block;
                margin: 0 auto;
                color: #ffffff;
            }
        }
    }
</style>





// WEBPACK FOOTER //
// src/pages/CreateApp/authorize.vue